module.exports = __webpack_public_path__ + "static/media/expand-square-black.737f590d.svg";